{
	"defaultErrorMessage": "Une erreur s'est produite lors de votre demande",
	"humanizedWithdrawStatus": {
		"paid": "Payé",
		"pending": "En attente",
		"processing": "En cours de traitement",
		"refused": "Refusé"
	},
	"humanizedWithdrawType": {
		"anticipation": "Anticipation",
		"withdraw": "Retirer",
		"withdrawAndAnticipation": "Retirer par anticipation"
	},
	"parsePaymentMethodV2": {
		"bonus": "Bonus",
		"app": "App",
		"cash": "Espèces",
		"creditCard": "Carte de crédit",
		"debitCard": "Carte de débit",
		"foodVoucher": "Ticket Restaurant",
		"pix": "Pix",
		"postEvent": "Post événement",
		"voucher": "Voucher",
		"zigPosCredit": "Crédit intégré",
		"zigPosDebit": "Débit intégré",
		"ame": "Ame",
		"anticipated": "Anticipé",
		"zigPosCreditInInstallments": "Crédit en versements",
		"rappi": "Rappi",
		"ifood": "Ifood",
		"uber": "Uber",
		"deliveryOnline": "Livraison en ligne",
		"dashboard": "Dashboard",
		"Online": "En ligne",
		"Cashless": "Cashless",
		"mbway": "MBWay",
		"total": "Total",
		"minimumConsumption": "Consommation minimale",
		"app": "App",
		"cashless": "Cashless",
		"unknown": "Inconnu"
	},
	"tabs": {
		"closings": "Clôture par le vendeur",
		"config": "Paramètres",
		"discount": "Réductions",
		"emissionErrors": "Erreurs d'émission",
		"emited": "Emissions",
		"extract": "Extrait du vendeur",
		"fiscalReport": "Rapport financier",
		"invoices": "Factures",
		"menus": "Menu",
		"missingInvoices": "Factures manquantes",
		"missingInvoicesForeign": "Factures en suspens",
		"notEmitedProducts": "Produits non distribués",
		"orderReport": "Rapport par Commande",
		"productReport": "Rapport par Produit",
		"productSoldByVendor": "Produits vendus par le vendeur",
		"products": "Produits",
		"search": "Rechercher",
		"trasactions": "Transactions",
		"recharges": "Rechargements",
		"vendorReport": "Rapport par Vendeur",
		"vendors": "Vendeurs",
		"vendorsRevenue": "Recettes Vendeur",
		"debtorsReport": "Factures Impayées"
	},
	"tooltips": {
		"bonusByProductReport": "Bonus par produit",
		"cashierBalance": "Recettes par caisse",
		"closeCashier": "Clôture de caisse",
		"entranceReport": "Entrée",
		"financialReport": "Clôture",
		"minimumConsumptionReport": "Consommation anticipée",
		"soldEntrances": "Total des entrées vendues",
		"soldProducts": "Total des produits vendus",
		"tipReport": "Rapport de Pourboire",
		"waiterReport": "Ventes",
		"vat": "La TVA est incluse dans le prix enregistré du produit.",
		"netValue": "La Valeur Nette est calculée en soustrayant la remise et le pourcentage de TVA de la valeur brute du produit.",
		"invoiceValue": "Correspond au montant total de la facture, qui peut inclure plus d'un produit, donc plus d'une ligne dans ce tableau."
	},
	"xlsx": {
		"data": "Données",
		"day": "{{title}} le jour {{date}}",
		"emissionInfo": "Document émis par {{currentEmployee}}, {{date}}",
		"selectedPeriod": "période sélectionnée du {{since}} au {{until}}",
		"sinceUntil": "{{title}} entre {{since}} et {{until}}",
		"zigEmissionDate": "ZIGPAY - Date d'émission {{date}}"
	},
	"displayFiltersInfo": {
		"none": "Filtres : aucun filtre appliqué",
		"hasFilters": "Filtres : {{filters}}"
	}
}
